import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';

//local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/notes-list';

const callItemNotesWidgetSuccess = ( props ) => {
    return (
        <div className='ui-call-item-notes-widget'>
            <TableSearchWidget
                templateType='inline'
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                onActionClick={ props.onActionClick }

                /**
                 * the list doesn't have any action associated
                 * we don't need to set `updateTableOnChange` to true
                 */
                // updateTableOnChange={ true }
                titleClassName={ 'ui-call-item-notes-widget__table__title'}
                className={ 'ui-call-item-notes-widget__table'}
            />
        </div>
    );
};

// set display name
callItemNotesWidgetSuccess.displayName = 'callItemNotesWidgetSuccess';

// set default props
callItemNotesWidgetSuccess.defaultProps = {
    componentData: {},
    layoutConfig: {},
    onActionClick: noop,
};

// prop types
callItemNotesWidgetSuccess.propTypes = {};

/*******************************/
// preloader view
const callItemNotesWidgetPreloader = ( props ) => {
    
    // widget class name
    const widgetClassName = classnames( 'ui-call-item-notes-widget-preloader', props.className );
    return (
        <div className={ widgetClassName }>
            <TableSearchInlineWidgetPreloader />
        </div>
    );
};

// set display name
callItemNotesWidgetPreloader.displayName = 'callItemNotesWidgetPreloader';

// set default props
callItemNotesWidgetPreloader.defaultProps = {};

// prop types
callItemNotesWidgetPreloader.propTypes = {};

/*******************************/
/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callItemNotesWidget as CallItemNotesWidgetWidget } from 'ui/views/widgets/callItemNotesWidget';
 *
 * // render
 * <CallItemNotesWidget propName='propValue'/>
 */
export const callItemNotesWidget = withNetworkState( callItemNotesWidgetPreloader, callItemNotesWidgetSuccess );
